import React, {useState, useEffect} from "react";
import "../styles/main.css";
import {StlViewer} from "react-stl-viewer";
import { useForm } from "react-hook-form";
import Accordion from 'react-bootstrap/Accordion';
import LoadingSpinner from "./LoadingSpinner";
import stpimg from '../images/stpimg.png';
import ChartComponent from "./ChartComponent";


function MainPanel() {
  const [file, setFile] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [isSelected, setIsSelected] = useState(false);
  const [isUrl1, setIsUrl1] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [url1, setUrl1] = useState();
  const [data, setData] = useState([]);
  const {  handleSubmit } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [physicalIDD, setPhysicalIDD] = useState([]);
  const [refreshCount, setRefreshCount] = useState(0);
  const [urlforchart, setUrlforchart] = useState("lego_stl_1");
  

  useEffect(() => {
    setFile("db2/lego_stl_1.stl");
    setSelectedFile("lego_stl_1.stl");
    const fetchFileNames = async () => {
      fetch('/file_names.json')
      .then(response => response.json())
      .then(data => setFileNames(data.files))
      .catch(error => console.error(error));
  };
  fetchFileNames();
  }, []);

  // Convert similarity values and calculate adjusted similarity
const adjustedSimilarity = data.map(item => {
  const convertedSimilarity = Math.round((item.similarity - 0.999) * 100000);
  return convertedSimilarity;
});

// Find the minimum similarity value among all parts
const minSimilarity = Math.min(...adjustedSimilarity);
console.log(minSimilarity);

  //log on submit
  const onSubmit = data =>
  {
    console.log(url1);
    console.log(data);
    //assign values to parameters
    let calculationMethod = "Wasserstein";
    console.log(calculationMethod);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");


    //create variable to pass as body  
    var raw = JSON.stringify({
      "key_file_path": selectedFile,
      "calculation_method": calculationMethod
    });


    //create headers for post request
    var requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: raw,
      redirect: 'follow'
    };

    setIsLoading(true);
    console.log("isloading" + isLoading);

    //send post request and fetch results
    fetch("/response", requestOptions)
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Fetch request failed");
    }
  })
  .then((data) => {
    // Rest of your code here
    console.log(data);
    setData(data.reverse());
    setIsLoading(false);
    console.log(data[0].physicalID);
    setIsActive(true);
    const similarItems = data.filter((item) => (Math.round((item.similarity - 0.999) * 100000)) >= 95);
    const unsimilarItems = data.filter((item) => (Math.round((item.similarity - 0.999) * 100000)) < 95);
    const firstFiveItems = unsimilarItems.slice(0, 3);
    const lastFiveItems = similarItems.slice(0, 5);
    const physicalIDs = [...lastFiveItems.map((item) => item.physicalID), ...firstFiveItems.map((item) => item.physicalID)];
    console.log(physicalIDs);
    setPhysicalIDD(physicalIDs);
    console.log(physicalIDD[1]);
    console.log(urlforchart);
  })
  .catch((error) => {
    // Handle fetch error here
    console.log("Fetch error:", error);
    setData(null); // Set data to null or handle the appropriate value
    setIsLoading(false);
  });

  }
  

    //set url to partid on partid button click
  const handlepartIdClick = (e) => {
    setIsLoading(false);
    console.log(e.target.id);
    var url = e.target.id;
    setUrlforchart(url);
    setUrl1("db2/"+url+".stl");
    console.log(url1);
    setIsUrl1(true);
    setIsSelected(!isSelected);
    setRefreshCount(refreshCount + 1);
    const collection = document.getElementsByClassName("partidbutton3");
    for (let i = 0; i < collection.length; i++) {
        collection[i].className = "partidbutton";
    }
    document.getElementById(url).className = "partidbutton3"
  }


    //set url to partid on partid button click
    const handlepartIdClick1 = (e) => {
      if (isActive===true) {
      window.location.reload();
      }
      setRefreshCount(refreshCount + 1);
      // setUrl1(false);
      // setData([]);
      console.log(e.target.id);
      var urln = e.target.id;
      var urlnew = urln.replace("new","");
      setUrlforchart(urlnew);
      setFile("db2/"+urlnew+".stl");
      console.log(file);
      setSelectedFile(urlnew+".stl");
      const collection = document.getElementsByClassName("partidbutton4");
      for (let i = 0; i < collection.length; i++) {
          collection[i].className = "fileslist";
      }
      document.getElementById(urln).className = "partidbutton4"
    }


  return (     
    
    <div className="BodyPanel1">
            <div className="pagetitle"> <h3>KI-Marktplatz Demonstrator: intelligentes Gleichteilemanagement</h3></div>
         <div className="firstpara">
       <p className="secondpara">Willkommen auf unserer Vorführseite. Hier wird ein Demonstrator für intelligente Gleichteilerkennung vorgestellt, der entwickelt wurde, um die Ähnlichkeiten verschiedener Komponenten zu vergleichen. 
       <br/><br/>
       Um die Funktionalität des Demonstrators zu testen, gehen Sie bitte wie folgt vor: Wählen Sie eine Komponente aus der "Liste aller Baugruppenkomponenten" unten aus. Vergleich starten: Wenn Sie das gewünschte Bauteil gefunden haben, klicken Sie auf "Start", um den Vergleich zu starten. Ergebnisse anzeigen: Nach einigen Sekunden werden die Ergebnisse in der "Liste der ähnlichen Komponenten" auf der rechten Seite des Bildschirms angezeigt. Wählen Sie eine ähnliche Komponente aus: Die aktuell in der Liste ausgewählte ähnliche Komponente wird im Bereich "3D-Vorschaubereich ausgewähltes Ähnlichtei" angezeigt. Wenn Sie diese einfachen Schritte befolgen, können Sie die Funktionalität des Demonstrators testen und verschiedene Komponenten problemlos vergleichen. Wenn Sie Fragen haben oder weitere Hilfe benötigen, wenden Sie sich bitte an unser Support-Team. Vielen Dank, dass Sie unseren Demonstrator nutzen!
       </p>
       <img className="stpimg" src={stpimg} alt="step"></img>
      </div> 
      
      {/* <div className="thirdpara">
       <p className="fourthpara">Um die Funktionalität des Demonstrators zu testen, folgen Sie bitte diesen Schritten:
        Wählen Sie eine Komponente: Sie können eine Komponente entweder aus der "Liste aller Baugruppenkomponenten" oder über die Pfeiltasten im "3D-Vorschaubereich" auswählen.
        Vergleich starten: Wenn Sie die gewünschte Komponente gefunden haben, klicken Sie auf "Start", um den Vergleich zu starten.
        Ergebnisse anzeigen: Nach einigen Sekunden werden die Ergebnisse in der "Liste ähnlicher Komponenten" auf der rechten Seite des Bildschirms angezeigt.
        Ähnliche Komponente auswählen: Die aktuell in der Liste ausgewählte ähnliche Komponente wird im Bereich "3D Vorschau der ausgewählten ähnlichen Komponente" angezeigt.
        Wenn Sie diesen einfachen Schritten folgen, können Sie die Funktionalität des Demonstrators testen und verschiedene Komponenten einfach vergleichen. Sollten Sie Fragen haben oder weitere Unterstützung benötigen, wenden Sie sich bitte an unser Support-Team.
        Vielen Dank für die Nutzung unseres Demonstrators!
       </p>
      </div>  */}
  
      <div className="BodyPanel">
      <form onSubmit={handleSubmit(onSubmit)}>


 
{isLoading && <LoadingSpinner />}
<div className="preview1">
<div className="previewheadingnew2"> Liste alle Baugruppenkomponenten </div>
<div className="previewheadingnew"> 3D-Vorschaubereich Referenzteil </div>
<div className="previewheading2"> 3D-Vorschaubereich ausgewähltes Ähnlichteil </div>
<div className="resultsheading"> Liste der ähnlichen Komponenten </div>

<div className="previewnew">
      <table>
        <thead>
          <tr>
            <th className="listheading">File Name</th>
          </tr>
        </thead>
        <tbody className="filesbody">
        {fileNames.map(fileName => (
            <tr>
              <td><p className="fileslist" id={fileName+"new"}  onClick={handlepartIdClick1}>Part {fileName.split('_')[2]}</p></td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>  
      
        <div className="third">
          <StlViewer
            width={300}
            height={350}
            orbitControls
            shadows
            url={file}
            left = {0}
        />  
        </div>
       

 
        <div className="second">
      {isUrl1 && <StlViewer
          id="newstl"
          width={300}
          height={350}
          orbitControls
          shadows
          top = {50}
          url={decodeURIComponent(url1)}
        />}
        </div>  

      </div>
  


<div className="myaccordion">
  <Accordion>
    <Accordion.Item eventKey="0">

    </Accordion.Item>
  </Accordion>
  <input className="submitform" type="submit" value="Start" disabled={isLoading}/>
</div>
</form>
<div className="previewfirst">
  <div className="preview">
      <table>
        <tbody>
      <tr>
      <th  className="previewtable"> Part ID and Similarity Score  </th> 
      <th className="sim"></th>
      </tr> 
      </tbody> 
      </table>
      {data && data.length > 0 &&  data.map((items) => (
         <button className= "partidbutton" onClick={handlepartIdClick} key={items} id={items.physicalID}>
         Part {items.physicalID.split('_')[2]}
         <br/> 
         {Math.round((((Math.round((items.similarity-0.999)*100000)-minSimilarity))/(100-minSimilarity))*100)}%
       </button> 
      ))}

        {/* {data && data.length>0 && data.map((items) => (
      <button className="partidbutton1"  onClick={handlepartIdClick} key={items} id={items.physicalID}>{items.similarity}</button>  
      
        ))} */} 
  </div>
</div>

</div>
    {isActive &&  <div className="chartlist">
        <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header> Expertenansicht zur technischen Klärung</Accordion.Header>
        <Accordion.Body>
  {isActive && <ChartComponent dataKeys={[physicalIDD[0], urlforchart]}  /> }
  </Accordion.Body>
      </Accordion.Item>
  </Accordion>
     </div> }
     {isActive && <div className="lastpara">
       <p className="fourthpara">
Die Expertenansicht bietet eine histogrammbasierte Bewertung: Die Ähnlichkeitsbewertung basiert hauptsächlich auf komponentenbasierten Histogrammen. Diese Histogramme ermöglichen eine detaillierte Analyse der technischen Aspekte der Komponente. Komponenten mit einer Übereinstimmung von über 95 % sind ähnlich. Im folgenden Diagramm werden die hochgeladenen Komponenten und ihre Histogramme in Blau angezeigt, während die ausgewählten Komponenten aus der Berechnungsliste und die zugehörigen Histogramme in Rot angezeigt werden. Wenn Sie Fragen haben oder weitere Hilfe benötigen, wenden Sie sich bitte an unser Support-Team. Vielen Dank, dass Sie unseren Demonstrator nutzen!

       </p>
      </div>  }

     {/* <canvas ref={canvasRef} width="400" height="400" /> */}
</div>
  ); 
};

export default MainPanel;
